module.exports = __webpack_public_path__ + "static/media/28-4.323ec729.mp3";